import script from "./RoomView.vue?vue&type=script&lang=ts&setup=true"
export * from "./RoomView.vue?vue&type=script&lang=ts&setup=true"

import "./RoomView.vue?vue&type=style&index=0&id=d30e1660&lang=scss&scoped=true"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-d30e1660"]])

export default __exports__